import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'

import { FormState, FormValidationFunction } from '@Shared/Components/Forms/FormElement.types'
import { TextInputValidationFn } from '@Shared/Components/Inputs/TextInput/TextInput'

export const NotEmptyValidation: FormValidationFunction<unknown> = (value, t) => {
  if (!isEmpty(value)) {
    return { state: FormState.VALID }
  }
  return {
    message: t('checkout:COF_WE_NEED_THIS_FIELD_TOO'),
    state: FormState.ERROR,
  }
}
export const NotEmptyValidationV2: TextInputValidationFn = (value) => {
  if (!isEmpty(value)) {
    return { success: true, errorMessage: '' }
  }
  return {
    errorMessage: 'common:COF_WE_NEED_THIS_FIELD_TOO',
    success: false,
  }
}
export const NotEmptyValidationExternalCustomerID: TextInputValidationFn = value => ({
  errorMessage: 'Deine persönliche DHL Postnummer für Abholstationen',
  success: !isEmpty(value),
})

export const StateNotEmptyValidationV2: (t) => TextInputValidationFn = t => value => ({
  errorMessage: t('checkout:COF_WE_NEED_THIS_FIELD_TOO'),
  success: !isEqual(value, 'null') && !!value && !isEmpty(value),
})
